import Image from './Image';
export default class Sponsor extends Image {
    level: string;
    constructor(payload: any) {
        super(payload);
        this.level = payload[3];
    }
}